import { absolutePath } from '@jane/shared/util';

export const getCanonicalPath = ({
  inIframe,
  isBoostWp,
  pagePath,
}: {
  inIframe: boolean;
  isBoostWp: boolean;
  pagePath: string;
}) => {
  const root = `${window.location.protocol}//${window.location.host}`;

  if (inIframe) {
    return absolutePath(pagePath);
  }

  if (!pagePath?.length) {
    return root;
  }

  const composedUrl = pagePath?.startsWith('/')
    ? `${root}${pagePath}`
    : `${root}/${pagePath}`;

  // Add trailing slash for compatibility with WP sites
  if (isBoostWp && !pagePath.endsWith('/')) {
    return `${composedUrl}/`;
  }

  return composedUrl;
};
